import * as React from "react";
import createSvgIcon from "../SvgIcon/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <g id="Layer_1">
      <polygon
        points="7.55 206.28 21.19 180 108.35 180 108.35 205.53 7.55 206.28"
        fill="none"
        stroke="#000"
        strokeWidth="4.6px"
        strokeMiterlimit="10"
      />
      <rect
        x="20.67"
        y="155.22"
        width="91"
        height="82"
        fill="none"
        stroke="#000"
        strokeWidth="4.25px"
        strokeMiterlimit="10"
      />
      <path
        d="M110.06,166.21c0,6.07-4.92,10.99-10.99,10.99s-10.99-4.92-10.99-10.99,4.92-10.99,10.99-10.99c2.71,0,5.18.98,7.1,2.6,2.38,2.02,3.89,5.03,3.89,8.39Z"
        fill="none"
        stroke="#000"
        strokeWidth="5.08px"
        strokeMiterlimit="10"
      />
      <path
        d="M100.46,64.75s37.79,36.64,2.75,92.65"
        fill="none"
        stroke="#000"
        strokeWidth="5.67px"
        strokeMiterlimit="10"
      />
      <path
        d="M101.16,69.98c-.71,5.89-6.05,10.09-11.94,9.38-5.89-.71-10.09-6.05-9.38-11.94s6.05-10.09,11.94-9.38c2.62.32,4.91,1.55,6.58,3.35,2.07,2.23,3.19,5.33,2.8,8.59Z"
        fill="none"
        stroke="#000"
        strokeWidth="4.96px"
        strokeMiterlimit="10"
      />
      <rect
        x="53.33"
        y="30.72"
        width="25.5"
        height="80.9"
        transform="translate(19.63 -14.12) rotate(14.31)"
        fill="none"
        stroke="#000"
        strokeWidth="5.67px"
        strokeMiterlimit="10"
      />
      <rect
        x="48.88"
        y="110.39"
        width="10.02"
        height="13.2"
        transform="translate(29.3 -9.44) rotate(13.73)"
        fill="none"
        stroke="#000"
        strokeWidth="5.16px"
        strokeMiterlimit="10"
      />
      <path
        d="M84.99,141.53c-9.69-2.74-17.27,4.81-25.15,8.93-3.52,1.84-7.19,2.53-11.1,1.71s-7.68-2.52-11.51-3.8c-4.32-1.44-8.92-2.27-13.38-.93-3.07.92-1.77,5.75,1.33,4.82,3.49-1.05,6.98-.28,10.36.82,3.73,1.21,7.32,2.84,11.14,3.75,4.1.98,8.29.99,12.27-.52s7.69-4.17,11.42-6.49,8.6-4.79,13.29-3.46c3.1.88,4.43-3.94,1.33-4.82h0Z"
        fill="none"
        stroke="#000"
        strokeMiterlimit="10"
      />
    </g>
  </React.Fragment>,
  "Stage3",
  {
    viewBox: "0 0 135 217.09",
    width: "82",
    height: "91",
  }
);
